import React, { useState } from "react";
import { ModuleAccessGuard } from '@/components/ModuleAccessGuard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BusinessIntelligenceDashboard } from "@/components/enterprise/BusinessIntelligenceDashboard";
import { CustomDomainManager } from "@/components/enterprise/CustomDomainManager";
import { AdvancedAPIManagement } from "@/components/enterprise/AdvancedAPIManagement";
import { ExecutiveReports } from "@/components/enterprise/ExecutiveReports";

export default function EnterpriseAnalytics() {
  return (
    <ModuleAccessGuard moduleId="enterprise_analytics">
      <div className="space-y-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Enterprise Analytics & Features</h1>
          <p className="text-muted-foreground mt-2">
            Advanced business intelligence, white-label solutions, and enterprise-grade features.
          </p>
        </div>

        <Tabs defaultValue="intelligence" className="space-y-6">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="intelligence">Business Intelligence</TabsTrigger>
            <TabsTrigger value="reports">Executive Reports</TabsTrigger>
            <TabsTrigger value="api">API Management</TabsTrigger>
            <TabsTrigger value="whitelabel">White-Label & Domains</TabsTrigger>
          </TabsList>

          <TabsContent value="intelligence">
            <BusinessIntelligenceDashboard />
          </TabsContent>

          <TabsContent value="reports">
            <ExecutiveReports />
          </TabsContent>

          <TabsContent value="api">
            <AdvancedAPIManagement />
          </TabsContent>

          <TabsContent value="whitelabel">
            <CustomDomainManager />
          </TabsContent>
        </Tabs>
      </div>
    </ModuleAccessGuard>
  );
}